/**
 * 将分转换为元
 * @param value - 分值，支持 string | number | undefined
 * @returns 元值的字符串表示，小数有值时保留小数，否则只输出整数
 */
export function fenToYuan(value) {
    try {
        if (value === undefined || value === null || value === '') {
            return '';
        }
        const fen = Number(value);
        if (Number.isNaN(fen)) {
            return '';
        }
        const yuan = fen / 100;
        const str = String(yuan);
        const dotIndex = str.indexOf('.');
        if (dotIndex === -1) {
            return str;
        }
        // 保留小数部分，去掉末尾多余的0
        const trimmed = str.replace(/0+$/, '');
        return trimmed.endsWith('.') ? trimmed.slice(0, -1) : trimmed;
    }
    catch {
        return '';
    }
}
